import { useParams } from "react-router";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Spinner } from "@/components/ui/spinner";
import { useServiceTypes } from "@/api/get-service-types";
import { useService } from "../api/get-services";
import { useUpdateService } from "../api/update-service";
import { ServiceForm } from "./service-form";
import { schema } from "./service-schema";

export const ServiceUpdate = () => {
    const { serviceGuid } = useParams();
    const { data: service, isLoading } = useService(serviceGuid);
    const { data: serviceTypes = [] } = useServiceTypes();

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            serviceTypes: [],
            appointmentTypeID: "",
            appointmentPrice: "",
            appointmentLength: "",
            turnaroundLength: "",
        },
        values: service
            ? {
                  ...service,
                  serviceTypes: service.serviceTypes?.split(",") || [],
                  appointmentPrice: service.appointmentPrice?.toFixed(2) ?? "",
              }
            : undefined,
    });

    // Submit
    const mutation = useUpdateService();

    const onSubmit = (data) => {
        mutation.mutate(data);
    };

    if (isLoading) {
        return (
            <div className="grid h-75 place-items-center">
                <Spinner size="lg" />
            </div>
        );
    }

    return (
        <ServiceForm
            methods={methods}
            onSubmit={onSubmit}
            service={service}
            serviceTypes={serviceTypes}
            isPending={mutation.isPending}
        />
    );
};
